<template>
    <div>
        <div class="page-content">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-12">
                        <div class="card border">
                            <div class="card-body">
                                <div class="page-title-box d-sm-flex align-items-center justify-content-between">
                                    <h4 class="mb-sm-0">Hasil Tryout Kedinasan</h4>
                                </div>
                                <div class="input-group">
                                    <input type="text" autocomplete="off" class="form-control" aria-describedby="emailHelp" placeholder="Cari data berdasarkan kata kunci..." v-model="keywords" v-on:keyup.enter="getData">
                                    <div class="input-group-append">
                                        <button v-on:click="getData" class="btn waves-effect waves-light btn-primary btn-icon btn-msg-send" type="button"><i
                                                class="fa fa-search"></i> Cari </button>
                                    </div>
                                </div>
                                <hr/>
                                <div v-if="dataFetch">
                                    <p>Sedang mengambil data...</p>
                                </div>

                                <div v-if="!dataFetch">
                                    <div v-if="dataList.length > 0" class="table-responsive mt-3">
                                        <table class="table">
                                            <thead>
                                                <tr>
                                                    <th style="width:5%" class="text-center">No</th>
                                                    <th>Nama Tryout</th>
                                                    <th>Tanggal Mengerjakan</th>
                                                    <th class="text-center" style="width:10%">Skor TWK</th>
                                                    <th class="text-center" style="width:10%">Skor TIU</th>
                                                    <th class="text-center" style="width:10%">Skor TKP</th>
                                                    <th class="text-center" style="width:10%">Total Skor</th>
                                                    <th class="text-center" style="width:10%">Status</th>
                                                    <th class="text-center" style="width:15%">Aksi</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(item, index) in dataList" :key="index">
                                                    <td class="text-center">
                                                        {{ (index + 1) + (pagination.currentPage - 1) * pagination.limit }}
                                                    </td>
                                                    <td>{{item.title}}</td>
                                                    <td>{{item.working_date}}</td>
                                                    <td v-if="item.status == 'open'" class="text-center">{{item.twk_scored}}</td>
                                                    <td v-if="item.status == 'open'" class="text-center">{{item.tiu_scored}}</td>
                                                    <td v-if="item.status == 'open'" class="text-center">{{item.tkp_scored}}</td>
                                                    <td v-if="item.status == 'open'" class="text-center">{{item.total_scored}}</td>
                                                    <td v-if="item.status == 'open'" class="text-center">
                                                        <span v-if="!item.graduated" class="badge bg-danger">Tidak Lulus</span>
                                                        <span v-if="item.graduated" class="badge bg-primary">Lulus</span>
                                                    </td>
                                                    <td v-if="item.status == 'open'" class="text-center">
                                                        <div class="button-items">
                                                            <router-link :to="{name : 'member_kedinasan_tryout_result_detail', params: {kedinasan_tryout_answer_id:item.kedinasan_tryout_answer_id}}" type="button" class="btn btn-primary btn-sm rounded"><i class="mdi mdi-format-list-text"></i> Lihat Detail</router-link>
                                                        </div>
                                                    </td>
                                                    <td v-if="item.status == 'lock'" colspan="6" class="text-center">
                                                        Hasil bisa dilihat pada <b>{{item.text_result_date}}</b>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>

                                    <nav v-if="dataList.length > 0" aria-label="navigation" class="mt-3">
                                        <v-pagination v-model="pagination.currentPage" :page-count="pagination.totalPages" :classes="pagination.bootstrapPaginationClasses" :labels="pagination.paginationAnchorTexts" v-on:change="getData()"></v-pagination>
                                    </nav>

                                    <div v-if="emptyState">
                                        <empty-state></empty-state>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import vPagination from 'vue-plain-pagination'

    export default {
        name: 'MemberKedinasanTryoutResult',
        metaInfo: {
            title: 'Hasil Tryout Kedinasan',
            titleTemplate: '%s - Gubuk Sains Prima'
        },
        components: {
            vPagination
        },
        data() {
            return {
                emptyState  : false,
                dataFetch   : false,
                dataList    : [],
                keywords    : "",
                pagination: {
                    currentPage : 1,
                    totalPages  : 0,
                    limit       : 10,
                    bootstrapPaginationClasses: {
                        ul: 'pagination justify-content-end',
                        li: 'page-item',
                        liActive: 'active',
                        liDisable: 'disabled',
                        button: 'page-link'
                    },
                    paginationAnchorTexts: {
                        first: 'First',
                        prev: 'Previous',
                        next: 'Next',
                        last: 'Last'
                    }
                }
            }
        },
        created() {
            this.getData();
        },
        methods: {
            getData: function() {
                let uri         = process.env.VUE_APP_APIHOST+'member/kedinasan/tryout/result';

                this.dataFetch  = true;                
                this.$http.get(uri,{
                    params : {
                        keywords : this.keywords,
                        page     : this.pagination.currentPage,
                        limit    : this.pagination.limit
                    }
                }).then(res => {
                    this.emptyState             = false;
                    this.dataFetch              = false;                
                    this.dataList               = res.data.data;
                    this.pagination.totalPages  = res.data.total_page;

                    if(this.dataList.length < 1) {
                        this.emptyState = true;
                    }
                });
            }
        }
    }
</script>